<template>
  <div class="management-page">
    <div class="management-content-list">
      <div
        class="management-content-item flex-between"
        v-for="(item, index) in managementContentList"
        :key="index"
        @click="handleGo(item, index)"
      >
        <div class="flex-rowl">
          <div class="icon">
            <img :src="item.icon" alt="" />
          </div>
          <p class="txt">{{ item.title }}</p>
        </div>
        <div class="icon-arrow-right">
          <img src="../assets/images/icon-arrow-right.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "Management",
  data() {
    return {
      managementContentList: [
        {
          title: "人员管理",
          icon: require("@/assets/images/icon-personnel-management.png")
        },
        {
          title: "用户数据",
          icon: require("@/assets/images/icon-user-center.png"),
          url: '/userIndex/userDate'
        },
        {
          title: "业务订单中心",
          icon: require("@/assets/images/icon-business-order-center.png"),
          url: '/OrderIndex/order-list'
        },
        {
          title: "业务区域管理",
          icon: require("@/assets/images/icon-business-area-management.png"),
          url: '/ManagementIndex/business-area-management'
        },
        {
          title: "客服&投诉管理",
          icon: require("@/assets/images/icon-customer-service-complaint-management.png")
        },
        {
          title: "服务收费标准管理",
          icon: require("@/assets/images/icon-business-order-center.png"),
          url: '/ManagementIndex/service-charge-management'
        },
        {
          title: "器材收费标准管理",
          icon: require("@/assets/images/icon-business-order-center.png"),
          url: '/ManagementIndex/equipment-charge-management'
        },
        {
          title: "陪护服务合作机构管理",
          icon: require("@/assets/images/icon-business-order-center.png"),
          url: '/ManagementIndex/service-cooperation-management'
        },
      ],
    };
  },
  methods: {
    handleGo(item) {
      if (item.url) {
        this.$router.push(item.url);
      }else {
        this.$toast('即将开放')
      }
    },
  }
};
</script>
  
  <style scoped lang="less">
/* 可添加样式 */
.management-page {
  padding-bottom: 200px;
  box-sizing: border-box;
  .management-content-list {
    width: 600px;
    margin: auto;
    padding-top: 100px;
    .management-content-item {
      width: 100%;
      height: 90px;
      border: 1px solid #aaaaaa;
      border-radius: 45px;
      margin-bottom: 30px;
      box-sizing: border-box;
      font-size: 24px;
      color: #333333;
      background: #fff;
      padding: 0 30px 0 54px;
      cursor: pointer;
      .icon {
        width: 49px;
        height: 30px;
        flex-shrink: 0;
        img {
          height: 100%;
          width: auto;
        }
      }
      .txt {
        white-space: nowrap;
      }
      .icon-arrow-right {
        widows: 12px;
        height: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>